import { IResponse, consumer, postFile } from "@bemap/utils";

const ENDPOINT = '/teams';

export const getTeamInfo = async (teamId: number): Promise<IResponse> => {
  try {
    return await consumer('GET', ENDPOINT, undefined, teamId);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
};

export const uploadTeamProfilePhoto = async (teamId: number, formData: FormData): Promise<IResponse> => {
  try {
    return await postFile(`${ENDPOINT}/${teamId}/profile-photo`, formData);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    };
  }
}; 